export const POSITION_STATUS_TEXT = {
    pending: 'Award not final',
    open: 'Open',
    filled: 'Filled',
    closed: 'Closed',
};

export const positionStatusText = (position) =>
    POSITION_STATUS_TEXT[position.status] || position.status;

export const needsStudents = (position) => position.openSlots > 0;
